import { makeStyles } from '@material-ui/styles'
import { METRICS_API_KEYS } from 'core/components/widgets/useTrendData'
import Card from 'core/elements/card'
import CardBody from 'core/elements/card/CardBody'
import Theme from 'core/themes/model'
import React from 'react'
import TrendGraphWidget from '../../../../core/components/widgets/TrendGraphWidget'
import Text from 'core/elements/Text'
import Divider from 'core/elements/Divider'

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  hostCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  card: {
    display: 'grid',
    gridTemplateRows: 'max-content max-content',
  },
  divider: {
    marginBottom: 0,
    marginTop: theme.spacing(1),
  },
}))

const enum SECTIONS {
  CORE_RESOURCES = 'Core Resources',
  NETWORK_RESOURCES = 'Network Resources',
  STORAGE_RESOURCES = 'Storage Resources',
}

const VMResourceUtilizationDashboard = ({
  resourceId,
  showOnlyForSelectedHosts = false,
  hostIds = [],
}: {
  resourceId?: string
  showOnlyForSelectedHosts?: boolean
  hostIds?: string[]
}) => {
  const classes = useStyles()

  const resourceceMap = resourceId
    ? [
        {
          title: 'CPU Usage',
          units: 'GHz',
          metricKey: METRICS_API_KEYS.PER_VM_CPU_USAGE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'Memory Usage',
          units: 'GiB',
          metricKey: METRICS_API_KEYS.PER_VM_MEMORY_USAGE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'CPU Throttling',
          units: '%',
          metricKey: METRICS_API_KEYS.PER_VM_CPU_THROTTLE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'Data Transmit Rate',
          units: 'Kbps',
          metricKey: METRICS_API_KEYS.PER_VM_NETWORK_TX_THROUGHPUT,
          section: SECTIONS.NETWORK_RESOURCES,
        },
        {
          title: 'Data Receive Rate',
          units: 'Kbps',
          metricKey: METRICS_API_KEYS.PER_VM_NETWORK_RX_THROUGHPUT,
          section: SECTIONS.NETWORK_RESOURCES,
        },
        {
          title: 'Disk Read IOPS',
          units: 'IOPS',
          metricKey: METRICS_API_KEYS.PER_VM_DISK_READ_IOPS,
          section: SECTIONS.STORAGE_RESOURCES,
        },
        {
          title: 'Disk Write IOPS',
          units: 'IOPS',
          metricKey: METRICS_API_KEYS.PER_VM_DISK_WRITE_IOPS,
          section: SECTIONS.STORAGE_RESOURCES,
        },
      ]
    : [
        {
          title: 'CPU Usage',
          units: 'GHz',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_CPU_USAGE
            : METRICS_API_KEYS.ALL_VMS_CPU_USAGE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'Memory Usage',
          units: 'GiB',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_MEMORY_USAGE
            : METRICS_API_KEYS.ALL_VMS_MEMORY_USAGE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'CPU Throttling',
          units: '%',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_CPU_THROTTLE
            : METRICS_API_KEYS.ALL_VMS_CPU_THROTTLE,
          section: SECTIONS.CORE_RESOURCES,
        },
        {
          title: 'Data Transmit Rate',
          units: 'Kbps',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_NETWORK_TX_THROUGHPUT
            : METRICS_API_KEYS.ALL_VMS_NETWORK_TX_THROUGHPUT,
          section: SECTIONS.NETWORK_RESOURCES,
        },
        {
          title: 'Data Receive Rate',
          units: 'Kbps',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_NETWORK_RX_THROUGHPUT
            : METRICS_API_KEYS.ALL_VMS_NETWORK_RX_THROUGHPUT,
          section: SECTIONS.NETWORK_RESOURCES,
        },
        {
          title: 'Disk Read IOPS',
          units: '',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_DISK_READ_IOPS
            : METRICS_API_KEYS.ALL_VMS_DISK_READ_IOPS,
          section: SECTIONS.STORAGE_RESOURCES,
        },
        {
          title: 'Disk Write IOPS',
          units: '',
          metricKey: showOnlyForSelectedHosts
            ? METRICS_API_KEYS.SELECTED_VMS_DISK_WRITE_IOPS
            : METRICS_API_KEYS.ALL_VMS_DISK_WRITE_IOPS,
          section: SECTIONS.STORAGE_RESOURCES,
        },
      ]

  const renderCard = (resource: any) => {
    return (
      <Card className={classes.card} withCustomBody>
        <CardBody>
          <TrendGraphWidget
            title={resource.title}
            units={resource.units}
            metricKey={resource.metricKey}
            resourceId={resourceId}
            resources={showOnlyForSelectedHosts ? hostIds : []}
          />
        </CardBody>
      </Card>
    )
  }

  return (
    <>
      <div className={classes.hostCards}>
        {resourceceMap.map((resource) => {
          return resource.section === SECTIONS.CORE_RESOURCES ? renderCard(resource) : null
        })}
      </div>
      <Text variant="subtitle2">Network </Text>
      <Divider className={classes.divider} />
      <div className={classes.hostCards}>
        {resourceceMap.map((resource) => {
          return resource.section === SECTIONS.NETWORK_RESOURCES ? renderCard(resource) : null
        })}
      </div>
      <Text variant="subtitle2">Storage </Text>
      <Divider className={classes.divider} />
      <div className={classes.hostCards}>
        {resourceceMap.map((resource) => {
          return resource.section === SECTIONS.STORAGE_RESOURCES ? renderCard(resource) : null
        })}
      </div>
    </>
  )
}

export default VMResourceUtilizationDashboard
